// extracted by mini-css-extract-plugin
module.exports = {"nameWrapper":"styles_nameWrapper__1eel2","infoWrapper":"styles_infoWrapper__jrTnU","contactWrapper":"styles_contactWrapper__v-WFJ"};